var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.00018 6H13.0002M7.00018 9H13.0002M7.00018 12H10.0002M5.49995 2H14.5001C15.6047 2 16.5002 2.89546 16.5001 4.00004L16.4999 16C16.4999 17.1046 15.6045 18 14.4999 18L5.49986 18C4.39529 18 3.49986 17.1045 3.49987 15.9999L3.49995 3.99999C3.49995 2.89543 4.39538 2 5.49995 2Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6d06df50e39ff162814e19d9f583c0d5.svg";
export { ForwardRef as ReactComponent };